import React, { useState } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function UpdateContactModal({ open, onClose, phone, onSave }) {
  const [mobile, setMobile] = useState(phone || "");

  const handleSave = () => {
    onSave(mobile);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <h2 className="text-base font-semibold">Update Contact Info</h2>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      <DialogContent>
        <div className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Mobile Phone No. <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              className="mt-1 block w-full rounded-md border border-gray-300 p-2 text-sm focus:ring-black focus:border-black"
              placeholder="123-345-1212"
            />
          </div>
          <button
            onClick={handleSave}
            className="w-full bg-black text-white py-2 rounded-md font-medium hover:bg-gray-800"
          >
            Save
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
